import React from 'react';
import { motion } from 'framer-motion';
import { ChatBubblePhone, ArrowDown } from './Icons';
interface HeroProps {
  lang: 'en' | 'es';
  setLang: (lang: 'en' | 'es') => void;
}
export const Hero: React.FC<HeroProps> = ({
  lang,
  setLang
}) => {
  const content = {
    en: {
      headline: 'Your Car. Any Brand. Best Deal.',
      subhead: "Miami's go-to sales pro. New & pre-owned vehicles across all makes and models — I find it, you drive it.",
      primaryCta: 'Get Started Now',
      secondaryCta: 'Get a Free Quote'
    },
    es: {
      headline: 'Tu Auto. Cualquier Marca. El Mejor Precio.',
      subhead: 'El asesor de confianza en Miami. Vehículos nuevos y usados de todas las marcas — yo lo encuentro, tú lo manejas.',
      primaryCta: 'Comienza Ahora',
      secondaryCta: 'Cotización Gratis'
    }
  };
  const t = content[lang];
  const scrollToForm = () => {
    const form = document.getElementById('quote-form');
    if (form) {
      form.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-22">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-23">
        <img src="https://cdn.magicpatterns.com/uploads/tjmmwwkCq3F7eDz7aoydR3/Confident_man_in_upscale_showroom.png" alt="Simon Alvarado" className="w-full h-full object-cover object-[center_20%]" data-id="element-24" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-black/85" data-id="element-25" />
      </div>

      {/* Language Toggle */}
      <div className="absolute top-6 right-6 z-20 flex gap-2" data-id="element-26">
        <button onClick={() => setLang('en')} className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors border ${lang === 'en' ? 'bg-white text-black border-white' : 'bg-transparent text-white/70 border-white/30 hover:border-white/60'}`} data-id="element-27">
          EN
        </button>
        <button onClick={() => setLang('es')} className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors border ${lang === 'es' ? 'bg-white text-black border-white' : 'bg-transparent text-white/70 border-white/30 hover:border-white/60'}`} data-id="element-28">
          ES
        </button>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center mt-20" data-id="element-29">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-5xl md:text-6xl lg:text-[56px] font-bold text-white leading-tight tracking-tight mb-6" data-id="element-30">
          {t.headline}
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.1,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-[#aaaaaa] max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-31">
          {t.subhead}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-32">
          <button onClick={scrollToForm} className="flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-4 bg-primary hover:bg-blue-600 text-white rounded-full font-medium transition-all transform hover:scale-[1.02] active:scale-[0.98]" data-id="element-33">
            <ChatBubblePhone size={20} data-id="element-34" />
            {t.primaryCta}
          </button>

          <button onClick={scrollToForm} className="flex items-center justify-center gap-2 w-full sm:w-auto px-8 py-4 bg-transparent border border-white/30 hover:border-white text-white rounded-full font-medium transition-all" data-id="element-35">
            {t.secondaryCta}
            <ArrowDown size={20} data-id="element-36" />
          </button>
        </motion.div>
      </div>
    </section>;
};